module.exports = "<app-course-type-list></app-course-type-list>"